import { NgModule } from '@angular/core';
import { ResetPasswordQuestionsAnswersComponent } from './reset-password-questions-answers/reset-password-questions-answers.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputValidationWrapComponent } from './input-validation-wrap/input-validation-wrap.component';

import { DialogModule } from '@progress/kendo-angular-dialog';
import { ButtonGroupModule, ButtonModule } from '@progress/kendo-angular-buttons';
import { FieldEyeComponent } from './field-eye/field-eye.component';
import { ProvidePasswordComponent } from './provide-password/provide-password.component';
import { ModalModule } from '@app/shared/dialogs/modal/modal.module';
import { ButtonGroupComponent } from './button-group/button-group.component';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@NgModule({
  imports: [
    CommonModule,
    DropDownsModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    ModalModule,
    ButtonGroupModule,
    TooltipDirective,
  ],
  declarations: [
    ResetPasswordQuestionsAnswersComponent,
    InputValidationWrapComponent,
    FieldEyeComponent,
    ProvidePasswordComponent,
    ButtonGroupComponent,
  ],
  exports: [
    ResetPasswordQuestionsAnswersComponent,
    FieldEyeComponent,
    InputValidationWrapComponent,
    ButtonGroupComponent,
  ],
})
export class CustomFormControlsModule {}
